<template>
<div>
   <iframe  style="width:100%;height:500px" :src="this.url"  title="SoftlineAngola"></iframe>
</div>
</template>

<script>
import axios from '../../plugins/axios'
import utilitarios from '../../plugins/utilitarios'
import impressaoService from '../../services/impressaoService';
import impressaoUtilitario from '../../utilitarios/impressao.utilitario';
const ls = require('local-storage')
export default {
  data: () => ({
    idCliente: ls.get('itemsFaturaEstaticos').cliente[0].idCliente,
    saldoEstudante: 0,
    lastInscricaoNaTurma: ls.get('lastMAtriculaOfStudent'),
    url: '',
    html: '',
    total_recibo: '57 500,00 AOK',
    empresa: {
      director1: 'CUSTÓDIO ADOLFO CALEI',
      director2: 'SANDRA DAVID GONÇALVES'
    },
    factura:
{
  'factura_recibo': ls.get('itemsFaturaEstaticos').documento,
  'bolseiro': (ls.get('bolseiro').length) ? (ls.get('bolseiro')[0].ongBolsa + '-' + ls.get('bolseiro')[0].percentagem) : 'Não',
  'cliente': ls.get('itemsFaturaEstaticos').cliente[0].nome,
  'matricula': ls.get('itemsFaturaEstaticos').cliente[0].numero_matricula,
  'curso': ls.get('itemsFaturaEstaticos').cliente[0].descricao,
  'classe': ls.get('itemsFaturaEstaticos').cliente[0].classe_descricao,
  'items': ls.get('itemsFatura'),
  'total_pagar': ls.get('itemsFaturaEstaticos').valorApagar,
  'total_pago': ls.get('itemsFaturaEstaticos').valorPago,
  'saldoDebitado': ls.get('saldoDescontado'),
  'troco': ls.get('itemsFaturaEstaticos').troco,
  'dataPagamento': ls.get('itemsFaturaEstaticos').dataPagamentoSelected,
  'totalMulta': ls.get('totalMulta'),
  'autor': ls.get('itemsFaturaEstaticos').autor,
  'number_item': 1,
  'tiDQ': 'Documento Processado por programa validado',
  'utilizador': 'Pedro'
},
    estudante:
{
  'number_recibo': '001',
  'number_deposito': '0109',
  'nome_empresa': 'INSTITUTO  SUPERIOR POLITÉCNICO PRIVADO DO LUENA',
  'cliente': 'Alexandrina Francisco de Almeida',
  'curso': 'ENSINO PRIMÁRIO',
  'turma': 'EP3ºM1B',
  'matricula': '3333332-26'

},
font: {
  titulo: (window.location.host.includes('192.168.20.2')) ? '10px': '10px',
  corpotexto:(window.location.host.includes('192.168.20.2')) ?'9px':'8px'
},
    mes_ano: '',
    data_actual: '',
    dataHora: '',
    hora: '',
    formatter: 0,
    config: null,
    baseUrl: ''
  }),
  async created () {
    await this.pesquisarStatusSaldo()
    this.data_hora()
    this.config = impressaoUtilitario.getConfig();
    console.log(this.config);
    console.log(this.baseUrl);
    this.getUrlImpressao();
  },

  methods: {

    async pesquisarStatusSaldo() {
      try {
        let params = {
          idCliente : this.idCliente
        }

        let result = await axios.post('/ObterStatusSaldoAluno', params).then(res => res.data);
        if (result.saldo) {
          this.saldoEstudante = result.saldo;
        } else {
          this.saldoEstudante = 0;
        }
      } catch (error) {
        // console.log(error);
      }
    },

    ObterClasse (classe){
      switch (classe) {
        case 1:
          return '10ª'
         case 2:
          return '11ª'
         case 3:
          return '12ª'
         case 4:
          return '13ª'
      
        default:
          return 'Inválido';
      }
    },  

    async getUrlImpressao() {
      try {
        this.baseUrl = await impressaoService.getBaseUrl().then((res) => res.data[0].url);
      } catch (error) {
        console.log(error);
      } finally {
        this.comporHtml()
      }
    }, 

    data_hora () {
      let data = new Date()
      this.mes_ano = (data.getFullYear()) + (data.getMonth() + 1)
      this.data_actual = data.getDate() + '/' + (data.getMonth() + 1) + '/' + (data.getFullYear())
      this.hora = (data.getHours()) + ':' + (data.getMinutes()) + ':' + (data.getSeconds())
      this.dataHora = data.getDate() + '-' + (data.getMonth() + 1) + '-' + (data.getFullYear()) + '  ' + (data.getHours()) + ':' + (data.getMinutes().toString().padStart(2, '0')) + ':' + (data.getSeconds())
    },

    async comporHtml () {
      try {
        this.html = `<style>
  
  .linha {
    border-bottom: 1px solid black;
    border-color: #808080;
    padding-top:2px
  }
  .space{
    padding-top:4px;
    padding-bottom:4px
  }
   th, td {
      font-family: sans-serif;
      font-size:`+this.font.corpotexto+`;
      
  }
#customers {
   border-collapse: collapse;
  width: 100%;
}

#customers td, #customers th {
  border: 1px solid #ddd;
  padding: 2px;
}

#customers tr:nth-child(even){background-color: #f2f2f2;}

#customers tr:hover {background-color: #DCDCDC;}

#customers th {
  padding-top: 2px;
  padding-bottom: 2px;
  text-align: center;
  background-color: #DCDCDC;
  color: black;
}
    </style>`
        
        let parcelas_recibo = ``
        this.factura.items.forEach(element => {
          console.log('element',element);
          parcelas_recibo += `<tr>
                          <td style="text-align:center;font-size:7px;">` + utilitarios.getMonthDescription(element.fkMes) + `</td>
                          <td style="text-align:center;font-size:7px;">`+ls.get('lastMAtriculaOfStudent')+`</td>
                          <td style="text-align:center;font-size:7px;">` + utilitarios.IntegerToMoneyValueFatura(element.preco) + `</td>
                          <td style="text-align:center;font-size:7px;">` + (Number.isInteger(element.multa) ? utilitarios.IntegerToMoneyValueFatura(element.multa) : 'N/A') + `</td>
                          <td style="text-align:center;font-size:7px;">` + element.emolumento + `</td>
                          <td style="text-align:center;font-size:7px;">` + this.factura.dataPagamento + `</td>
                          <td style="text-align:center;font-size:7px;">`+ utilitarios.IntegerToMoneyValueFatura((element.descontoInteiro === null ||element.descontoInteiro === undefined )?0:element.descontoInteiro)+`</td>
                          <td style="text-align:center">OK</td>
                          <td style="text-align:right;">` + utilitarios.IntegerToMoneyValueFatura(element.subtotal) + `</td>
                        </tr>
                        `
        })

        for (let index = 0; index < 2; index++) {
          this.html += ` 
    
    <div style="text-align:left;margin:10px;margin-top:0px" class="invoice-box">
    <table style="border:0px solid black;margin-left:0px;margin-right:auto;">
    <tr>
        <td>
             <div>
   <span style="padding-top:1px!important">  <img src="` + this.baseUrl + `/readfile/` + this.config.logo + `" alt="Snow" style="width:50%; max-width:80px;" /></span>
    </div>
        </td>
         <td> 
        <h2 style="text-decoration: underline">` + this.config.descricao + `</h2>
        </td>
         
    </tr>    
       </table>

      <table style="border:0px solid black;border-collapse: collapse;width:100%">
      <tr><td colspan="6"><div class="linha"></div> </td> <td colspan="2"><div class="linha" style="margin-left:10px"></div> </td> </tr>
      <tr>
      <td colspan="6" style="text-align:center;">
       <div style="font-size: `+this.font.titulo+`;"><strong>Factura Recibo - ` + this.factura.factura_recibo + `</strong></div>
      </td>
      <td colspan="2" style="text-align:center;">
       <div style="font-size: `+this.font.titulo+`;"><strong>` + (index + 1) + `ª VIA </strong></div>
      </td>
      </tr>
       
      <tr><td colspan="6"><div class="linha"></div> </td> <td colspan="2"><div class="linha" style="margin-left:10px"></div> </td> </tr>


      <tr>
      <td colspan="2"> <strong> Data da Operação:</strong>  ` + utilitarios.ObterDataActural() + `</td>
      <td colspan="4"  > <strong> Valor do Recibo:</strong> ` + utilitarios.IntegerToMoneyValueFatura(this.factura.total_pagar) + `</td>
      <td colspan="2" style="text-align:right"> <strong> Ano académico:</strong>  ` + this.ObterClasse(this.factura.classe) + `</td>
       </tr>

      <tr>
      <td colspan="2"> <strong> Nº de Matrícula:</strong>  ` + this.factura.matricula + `</td>
      <td colspan="4"  > <strong> Curso:</strong>  ` + this.factura.curso + `</td>
      <td colspan="2" style="text-align:right"> <strong> Nº de Depósito:</strong> N/A</td>
      </tr>
      <tr>
      <td colspan="2"> <strong> Bolseiro(a):</strong>  ` + this.factura.bolseiro + `</td>
      <td colspan="2"> <strong> Saldo Actual:</strong>  ` + utilitarios.IntegerToMoneyValueFatura(this.saldoEstudante) + `</td>
        </tr>

     <tr>
      <td colspan="8" class="space">
      Recebemos de  <b> ` + this.factura.cliente + ` </b>, o valor <strong>` + utilitarios.IntegerToMoneyValueFatura(this.factura.total_pagar) + `</strong> referente a(s) parcela(s) listada(s) abaixo:  </td>
     </tr>
     </table>       
    
    <table id="customers">
  <tr>
    <th width="12%">Parcela</th>
    <th width="12%">Turma</th>
    <th width="10%">P. Unit</th>
    <th width="10%">Multa</th>
    <th width="18%">Tipo de Título</th>
    <th width="10%">Data</th>
    <th width="5%">Desconto</th>
    <th width="5%">Situação</th>
    <th width="10%">Valor Pago</th>
  </tr>
  ` + parcelas_recibo + `
  <tr>
  <td colspan="8" style="text-align:right">Saldo Debitado: </td>
  <td  style="text-align:right"> ` + utilitarios.IntegerToMoneyValueFatura(this.factura.saldoDebitado) + ` </td>
  </tr> 
  <tr>
  <td colspan="8" style="text-align:right">Valor pago: </td>
  <td  style="text-align:right"> ` + utilitarios.IntegerToMoneyValueFatura(this.factura.total_pago) + ` </td>
  </tr> 
  <tr>
  <td colspan="8" style="text-align:right">Total Multa: </td>
  <td style="text-align:right">` + utilitarios.IntegerToMoneyValueFatura(this.factura.totalMulta) + `</td>
  </tr> 
  <tr>
  <td colspan="8" style="text-align:right">Total Geral: </td>
  <td  style="text-align:right"> ` + utilitarios.IntegerToMoneyValueFatura(this.factura.total_pagar) + ` </td>
  </tr> 
</table>

<table style="border:0px solid black;border-collapse: collapse;width:100%; margin-top:40px">

      <tr><td colspan="4"><div class="linha"></div> </td> <td colspan="4"><div class="linha" style="margin-left:30px"></div> </td> </tr>
      <tr><td colspan="4" style="text-align:center">` + this.factura.cliente + ` </td> <td colspan="4" style="text-align:center">` + this.factura.autor + `</td> </tr>
</table>
<hr>    
              `

            }
            let options = {
              'format': 'A4',
              'border': {'right': '9mm','left': '9mm'},
              'header': {'height': '10mm' },
              'footer': {'height': '10mm'}
            }

            impressaoService.htmlToPdf(this.html, options);
      } catch (error) {
        console.log(error);
      }
    }
  }
}

</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}
.progressCircularIsMatriculaURL {
  margin: 1rem;

  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -100px;

}
</style>
